import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M1.157 8.889A6.126 6.126 0 0 1 12 4.98a6.126 6.126 0 1 1 8.707 8.556l-8.027 7.435a1 1 0 0 1-1.359 0l-8.017-7.425a6.11 6.11 0 0 1-2.146-4.657Z"
    }, null, -1)
  ]));
}
const interfaceFavoriteHeart = { render };
export {
  interfaceFavoriteHeart as default,
  render
};
//# sourceMappingURL=interface-favorite-heart.svg.js.map
